<template>
  <div class="animated fadeIn">
    <Row style="padding-left: 50px;">
      业务员:
      <Select
        size="small"
        style="width: 200px; margin-right: 3px;"
        v-model="selectBusinessUserId">
        <Option v-for="(option, index) in marketSales" :value="option.value" :key="option.value">{{option.label}}</Option>
      </Select>
      年份:
      <Input v-model="year" style="width: 100px; margin-right: 3px;"></Input>
      月份:
      <Input v-model="month" style="width: 100px; margin-right: 3px;"></Input>
      <Button size="small" style="margin-right: 3px;" @click="onSearch">查询</Button>
<!--      <Button @click="onExportExcel">导出Excel</Button>-->
    </Row>

    <Row :gutter="16" style="margin-top:20px">
      <Col :xs="24" :sm="12" :md="12" :lg="12">
        <div class="state-overview">
          <Col span="12">

            <div class="panel purple">
              <!--<div class="symbol">-->
              <!--<Icon type="clipboard" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  新装统计数据
                </div>
                <div class="title">
                  个人直营总营收：￥ {{personalDevelopReport.directSaleTotal}}
                </div>
                <div class="title">
                  个人直营总数量：{{personalDevelopReport.directSaleAmount}} 单
                </div>
                <div class="title">
                  个人渠道总营收：￥ {{personalDevelopReport.channelSaleTotal}}
                </div>
                <div class="title">
                  个人渠道总数量：{{personalDevelopReport.channelSaleAmount}} 单
                </div>
              </div>
            </div>

          </Col>
          <Col span="12">
            <div class="panel red">
              <!--<div class="symbol">-->
              <!--<Icon type="easel" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  三方监控
                </div>
                <div class="title">
                  直营营收：￥ {{personalDevelopReport.directSaleMonitorTotal}}
                </div>
                <div class="title">
                  直营数量：{{personalDevelopReport.directSaleMonitorAmount}} 单
                </div>
                <div class="title">
                  渠道营收：￥ {{personalDevelopReport.channelSaleMonitorTotal}}
                </div>
                <div class="title">
                  渠道数量：{{personalDevelopReport.channelSaleMonitorAmount}} 单
                </div>
              </div>
            </div>
          </Col>
        </div>

        <div class="state-overview">
          <Col span="8">

            <div class="panel blue">
              <!--<div class="symbol">-->
              <!--<Icon type="cash" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  主动安全设备
                </div>
                <div class="title">
                  直营营收：￥ {{personalDevelopReport.directSaleADASTotal}}
                </div>
                <div class="title">
                  直营数量：{{personalDevelopReport.directSaleADASAmount}} 单
                </div>
                <div class="title">
                  渠道营收：￥ {{personalDevelopReport.channelSaleADASTotal}}
                </div>
                <div class="title">
                  渠道数量：{{personalDevelopReport.channelSaleADASAmount}} 单
                </div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="panel green">
              <!--<div class="symbol">-->
              <!--<Icon type="eye" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  部标设备
                </div>
                <div class="title">
                  直营营收：￥ {{personalDevelopReport.directSaleJT808Total}}
                </div>
                <div class="title">
                  直营数量：{{personalDevelopReport.directSaleJT808Amount}} 单
                </div>
                <div class="title">
                  渠道营收：￥ {{personalDevelopReport.channelSaleJT808Total}}
                </div>
                <div class="title">
                  渠道数量：{{personalDevelopReport.channelSaleJT808Amount}} 单
                </div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="panel blue">
              <!--<div class="symbol">-->
              <!--<Icon type="pricetags" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  其他设备
                </div>
                <div class="title">
                  直营营收：￥ {{personalDevelopReport.directSaleOtherTotal}}
                </div>
                <div class="title">
                  直营数量：{{personalDevelopReport.directSaleOtherAmount}} 单
                </div>
                <div class="title">
                  渠道营收：￥ {{personalDevelopReport.channelSaleOtherTotal}}
                </div>
                <div class="title">
                  渠道数量：{{personalDevelopReport.channelSaleOtherAmount}} 单
                </div>
              </div>
            </div>
          </Col>
        </div>
      </Col>
      <Col :xs="24" :sm="12" :md="12" :lg="12">
        <chart :options="useOption" class="echarts" style="width: 100%;" id="chart"></chart>
      </Col>
    </Row>

    <Row :gutter="16" style="margin-top:20px">
      <Col :xs="24" :sm="12" :md="12" :lg="12">
        <div class="state-overview">
          <Col span="12">

            <div class="panel purple">
              <!--<div class="symbol">-->
              <!--<Icon type="clipboard" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  续费统计数据
                </div>
                <div class="title">
                  个人续费收款金额：￥ {{personalRenewReport.total}}
                </div>
                <div class="title">
                  个人续费收款数量：{{personalRenewReport.amount}} 单
                </div>
                <div class="title">
                  个人应收金额：￥ {{personalRenewReport.expectedTotal}}
                </div>
                <div class="title">
                  个人应收数量：{{personalRenewReport.expectedAmount}} 单
                </div>
              </div>
            </div>

          </Col>
          <Col span="12">
            <div class="panel red">
              <!--<div class="symbol">-->
              <!--<Icon type="easel" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  三方监控
                </div>
                <div class="title">
                  收款金额：￥ {{personalRenewReport.monitorTotal}}
                </div>
                <div class="title">
                  收款数量：{{personalRenewReport.monitorAmount}} 单
                </div>
                <div class="title">
                  应收金额：￥ {{personalRenewReport.expectedMonitorTotal}}
                </div>
                <div class="title">
                  应收数量：{{personalRenewReport.expectedMonitorAmount}} 单
                </div>
              </div>
            </div>
          </Col>
        </div>

        <div class="state-overview">
          <Col span="8">

            <div class="panel blue">
              <!--<div class="symbol">-->
              <!--<Icon type="cash" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  主动安全设备
                </div>
                <div class="title">
                  收款金额：￥ {{personalRenewReport.adasTotal}}
                </div>
                <div class="title">
                  收款数量：{{personalRenewReport.adasAmount}} 单
                </div>
                <div class="title">
                  应收金额：￥ {{personalRenewReport.expectedAdasTotal}}
                </div>
                <div class="title">
                  应收数量：{{personalRenewReport.expectedAdasAmount}} 单
                </div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="panel green">
              <!--<div class="symbol">-->
              <!--<Icon type="eye" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  部标设备
                </div>
                <div class="title">
                  收款金额：￥ {{personalRenewReport.jt808Total}}
                </div>
                <div class="title">
                  收款数量：{{personalRenewReport.jt808Amount}} 单
                </div>
                <div class="title">
                  应收金额：￥ {{personalRenewReport.expectedJt808Total}}
                </div>
                <div class="title">
                  应收数量：{{personalRenewReport.expectedJt808Amount}} 单
                </div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="panel blue">
              <!--<div class="symbol">-->
              <!--<Icon type="pricetags" size="50" color="white"></Icon>-->
              <!--</div>-->
              <div class="state-value">
                <div class="title">
                  其他设备
                </div>
                <div class="title">
                  收款金额：￥ {{personalRenewReport.otherTotal}}
                </div>
                <div class="title">
                  收款数量：{{personalRenewReport.otherAmount}} 单
                </div>
                <div class="title">
                  应收金额：￥ {{personalRenewReport.expectedOtherTotal}}
                </div>
                <div class="title">
                  应收数量：{{personalRenewReport.expectedOtherAmount}} 单
                </div>
              </div>
            </div>
          </Col>
        </div>
      </Col>
      <Col :xs="24" :sm="12" :md="12" :lg="12">
        <chart :options="renewOption" class="echarts" style="width: 100%;" id="renewChart"></chart>
      </Col>
    </Row>
<!--    <Row>-->
<!--      <Col :xs="24" :sm="24" :md="24" :lg="24">-->
<!--        <chart :options="detailOption" style="height: 300px;" class="echarts" id="detailChart"-->
<!--               ref="detailChart"></chart>-->
<!--      </Col>-->
<!--    </Row>-->
  </div>
</template>

<script>

import echarts from 'echarts'

import Vue from 'vue'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { explainAlarmSign, explainState } from '@/libs/jt808util'

var posList = [
  'left', 'right', 'top', 'bottom',
  'inside',
  'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
  'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
]

export default {
  name: 'dayreport',
  components: {
    echarts
  },
  data () {
    return {

      year: 2023,
      month: 1,

      selectBusinessUserId: 0,
      marketSales: [],

      dateFilter: [],

      pageindex: 1,
      list_loadding: false,

      personalRenewReport: {
        reportName: null,
        startDatetime: 0,
        endDatetime: 0,
        businessUserId: 0,
        businessUser: null,

        total: 0,
        amount: 0,
        jt808Total: 0,
        jt808Amount: 0,
        adasTotal: 0,
        adasAmount: 0,
        otherTotal: 0,
        otherAmount: 0,
        monitorTotal: 0,
        monitorAmount: 0,

        expectedTotal: 0,
        expectedAmount: 0,
        expectedJt808Total: 0,
        expectedJt808Amount: 0,
        expectedAdasTotal: 0,
        expectedAdasAmount: 0,
        expectedOtherTotal: 0,
        expectedOtherAmount: 0,
        expectedMonitorTotal: 0,
        expectedMonitorAmount: 0
      },

      personalDevelopReport: {
        reportName: null,
        startDatetime: 0,
        endDatetime: 0,
        businessUserId: 0,
        businessUser: null,

        directSaleTotal: 0,
        directSaleAmount: 0,
        directSaleJT808Total: 0,
        directSaleJT808Amount: 0,
        directSaleADASTotal: 0,
        directSaleADASAmount: 0,
        directSaleOtherTotal: 0,
        directSaleOtherAmount: 0,
        directSaleMonitorTotal: 0,
        directSaleMonitorAmount: 0,

        channelSaleTotal: 0,
        channelSaleAmount: 0,
        channelSaleJT808Total: 0,
        channelSaleJT808Amount: 0,
        channelSaleADASTotal: 0,
        channelSaleADASAmount: 0,
        channelSaleOtherTotal: 0,
        channelSaleOtherAmount: 0,
        channelSaleMonitorTotal: 0,
        channelSaleMonitorAmount: 0
      },

      transfer: true,
      selectDatetime: null,
      useData: [{
        value: 0,
        name: '主动安全'
      }, {
        value: 0,
        name: '部标'
      }, {
        value: 0,
        name: '其他'
      }],

      renewData: [{
        value: 0,
        name: '主动安全'
      }, {
        value: 0,
        name: '部标'
      }, {
        value: 0,
        name: '其他'
      }],

      detailChartConfig: {
        configParameters: {
          rotate: {
            min: -90,
            max: 90
          },
          align: {
            options: {
              left: 'left',
              center: 'center',
              right: 'right'
            }
          },
          verticalAlign: {
            options: {
              top: 'top',
              middle: 'middle',
              bottom: 'bottom'
            }
          },
          position: {
            options: echarts.util.reduce(posList, function (map, pos) {
              map[pos] = pos
              return map
            }, {})
          },
          distance: {
            min: 0,
            max: 100
          }
        },

        config: {
          rotate: 90,
          align: 'left',
          verticalAlign: 'middle',
          position: 'insideBottom',
          distance: 15,
          onChange: () => {
            var labelOption = {
              normal: {
                rotate: this.detailChartConfig.config.rotate,
                align: this.detailChartConfig.config.align,
                verticalAlign: this.detailChartConfig.config.verticalAlign,
                position: this.detailChartConfig.config.position,
                distance: this.detailChartConfig.config.distance
              }
            }

            this.$refs.detailChart.setOption({
              series: [{
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }]
            })
          }
        }
      },

      useOption: {
        backgroundColor: '#49586e',
        title: {
          text: '新增数量',
          x: '0%',
          y: 'center',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 20,
            color: '#fff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: '25%',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
            color: '#fff'
          },
          data: ['主动安全', '部标', '其他']
        },
        series: [{
          type: 'pie',
          selectedMode: 'single',
          center: ['30%', '50%'],
          radius: ['50%', '80%'],
          // color: ['#86D560', '#AF89D6', '#59ADF3', '#FF999A', '#FFCC67'],
          color: ['#AF89D6', '#5ab6df', '#6a8bc0', '#4acacb', '#fe8676'],

          label: {
            normal: {
              position: 'inner',
              formatter: '{d}%',

              textStyle: {
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 12
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: []
        }]
      },
      renewOption: {
        backgroundColor: '#49586e',
        title: {
          text: '续费数量',
          x: '0%',
          y: 'center',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 20,
            color: '#fff'
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: '25%',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
            color: '#fff'
          },
          data: ['主动安全', '部标', '其他']
        },
        series: [{
          type: 'pie',
          selectedMode: 'single',
          center: ['30%', '50%'],
          radius: ['50%', '80%'],
          // color: ['#86D560', '#AF89D6', '#59ADF3', '#FF999A', '#FFCC67'],
          color: ['#AF89D6', '#5ab6df', '#6a8bc0', '#4acacb', '#fe8676'],

          label: {
            normal: {
              position: 'inner',
              formatter: '{d}%',

              textStyle: {
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 12
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: []
        }]
      },
      detailOption: {
        title: { text: '当日使用情况' },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        calculable: true,
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        }
      }
    }
  },
  methods: {
    onExportExcel () {
      let selectDatetime = this.selectDatetime.Format('yyyy-MM-dd%2000:00:00')
      window.location.href = '/api/operationstatistics/generatedayreport/' + selectDatetime
    },
    onSearch () {
      if (!this.selectBusinessUserId) {
        this.$Message.error('无效业务员id')
        return
      }

      if (!this.year || !this.month) {
        this.$Message.error('无效统计时间段')
        return
      }

      store.dispatch('DevelopReportServ_StatisticsPersonMonth', {
        params: {
          userId: this.selectBusinessUserId,
          year: this.year,
          month: this.month
        },
        urlparams: null
      }).then(() => {
        this.personalDevelopReport = store.getters.get_DevelopReport_StatisticsPersonMonthResult
        this.useData[0].value = this.personalDevelopReport.directSaleADASAmount + this.personalDevelopReport.channelSaleADASAmount
        this.useData[1].value = this.personalDevelopReport.directSaleJT808Amount + this.personalDevelopReport.channelSaleJT808Amount
        this.useData[2].value = this.personalDevelopReport.directSaleOtherAmount + this.personalDevelopReport.channelSaleOtherAmount
      }).catch(err => {
        this.$Message.error(err)
      })

      store.dispatch('RenewReportServ_StatisticsPersonMonth', {
        params: {
          userId: this.selectBusinessUserId,
          year: this.year,
          month: this.month
        },
        urlparams: null
      }).then(() => {
        this.personalRenewReport = store.getters.get_RenewReport_StatisticsPersonMonthResult
        this.renewData[0].value = this.personalRenewReport.adasAmount
        this.renewData[1].value = this.personalRenewReport.jt808Amount
        this.renewData[2].value = this.personalRenewReport.otherAmount
        console.log(this.renewData)
        console.log(this.personalRenewReport)
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onShow () {
      this.useOption.series[0].data = this.useData
      this.renewOption.series[0].data = this.renewData

      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [7] }
      }).then(() => {
        let marketSales = store.getters.get_User_GetAllUsersResult
        this.marketSales = marketSales.map(item => {
          return { label: item.realName, value: item.id }
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.onShow()
    })
  }
}
</script>

<style scoped>

.echarts {
  border-radius: 4px;
  height: 300px;
  width: 100%;
}

.state-overview {
  color: #fff
}

.state-overview .ivu-col {
  margin-bottom: 20px
}

.state-overview .state-value .value {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px
}

.state-overview .state-value .title {
  font-size: 14px
}

.state-value {
  width: 100%;
  display: inline-block
}

.symbol {
  width: 35%;
  display: inline-block
}

.state-overview .panel {
  border-radius: 4px;
  padding: 25px 20px
}

.panel.purple {
  background: #6a8abe;
  box-shadow: 0 5px 0 #5f7cab
}

.panel.red {
  background-color: #fc8675;
  box-shadow: 0 5px 0 #e27869
}

.panel.blue {
  background: #5ab6df;
  box-shadow: 0 5px 0 #51a3c8
}

.panel.green {
  background: #4acacb;
  box-shadow: 0 5px 0 #42b5b6
}

.dash_income_chart {
  float: left
}

.ivu-row {
  margin-bottom: 20px !important
}

.dash_income {
  border-radius: 4px;
  background-color: #fff;
  height: 80px;
  padding: 15px
}

.staff_name {
  font-weight: 900;
  font-size: 16px
}

.staff_progress {
  margin-left: 10px;
  width: 90%
}

.staff_progress p {
  margin: 0
}

.staff_list {
  border-radius: 4px;
  margin-top: 0;
  height: 90px;
  display: flex;
  align-items: center
}

.animated {
  background-color: #eff0f4
}

li {
  margin-bottom: 11px;
  margin-left: 10px;
  margin-right: 10px
}

.num {
  font-weight: 700
}

.time {
  font-size: 14px;
  font-weight: 700
}

.content {
  padding-left: 5px
}

.dashboard_feature {
  text-align: center
}

.demo-carousel {
  height: 600px;
  line-height: 200px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background: #506b9e
}

.demo-carousel img {
  height: 100%;
  width: 100%
}

h3, h4, h5 {
  margin: 12px
}

h3 {
  margin-bottom: 20px
}

p {
  margin: 12px
}

.row-margin-top {
  margin-top: 30px
}

.state-info {
  position: absolute;
  right: 15px;
  top: 20px;
  margin-bottom: 30px
}

.state-info .panel {
  margin-bottom: 20px;
  float: right;
  margin-left: 15px
}

.panel {
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05)
}

.panel-body {
  padding: 15px
}

.state-info .panel .summary {
  float: left;
  margin-right: 20px
}

.state-info .panel .summary span {
  color: #49586e;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 10px
}

.state-info .panel .summary h3.red-txt {
  color: #fc8675
}

.state-info .panel .summary h3.green-txt {
  color: #65cea7
}

.state-info .panel .summary h3 {
  font-size: 200%;
  font-weight: 700;
  line-height: 20px;
  margin: 0
}

.page-heading h3 {
  color: #49586e;
  font-size: 25px;
  font-size: 11%;
  font-weight: 400;
  margin: 10px 0
}

.chart-bar {
  float: right;
  margin-top: 5px
}

.chart-bar img {
  display: inline-block;
  width: 68px;
  height: 45px;
  vertical-align: top
}

@media screen and (max-width: 767px) {
  .state-info {
    position: static;
    width: 100%;
    margin-top: 15px
  }

  .state-info .panel {
    width: 100%
  }
}

.panel.blue-box {
  background: none repeat scroll 0 0 #5ab5de;
  box-shadow: 0 5px 0 #51a3c7;
  color: #fff
}

.twt-info h3 {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 900;
  margin: 10px 0 30px 0;
  text-align: center
}

.twt-info p {
  font-size: 18px;
  line-height: 25px;
  font-style: italic;
  margin: 0 0 20px 0;
  text-align: center
}

.twt-info p a {
  color: #98fdf4
}

.media:first-child {
  margin-top: 0
}

.media.usr-info > .pull-left {
  margin-right: 20px;
  margin-top: 10px
}

.media > .pull-left {
  margin-right: 10px
}

.pull-left {
  float: left
}

.pull-left {
  float: left !important
}

.custom-trq-footer {
  background: none repeat scroll 0 0 #4eb6b7 !important;
  box-shadow: 0 5px 0 #46a3a4;
  color: #fff;
  border-top: none
}

.panel-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px
}

.usr-info .thumb {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  -webkit-border-radius: 50%
}

.usr-info img {
  vertical-align: middle
}

.usr-info h4 {
  color: #658585;
  margin-bottom: 0
}

.media-heading {
  margin: 0 0 5px
}

.usr-info .media-body span {
  color: #ea755c;
  font-size: 12px;
  margin-bottom: 20px;
  display: inline-block
}

.usr-info .media-body p {
  color: #b6bcbc
}

ul.user-states {
  list-style-type: none;
  padding: 20px 0
}

ul.user-states li {
  text-align: center;
  float: left;
  width: 33%;
  font-size: 18px;
  margin: 0
}

</style>
